import { createGetDisabledTrigger, isPopoverElement } from './selectionLimitPopoverUtils.js';

export const attachSelectionLimitTableListeners = ({
    tableEl,
    checkboxColId,
    closeDelayMs,
    onOpen,
    onClose,
}) => {
    const getDisabledTrigger = createGetDisabledTrigger(checkboxColId);
    let activeTrigger = null;
    let closeTimer = null;

    const clearCloseTimer = () => {
        if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
        }
    };

    const scheduleClose = () => {
        clearCloseTimer();
        closeTimer = setTimeout(() => {
            activeTrigger = null;
            onClose();
        }, closeDelayMs);
    };

    const handleMouseOver = (event) => {
        const trigger = getDisabledTrigger(event.target);
        if (!trigger) return;

        clearCloseTimer();
        activeTrigger = trigger;
        onOpen(trigger);
    };

    const handleMouseOut = (event) => {
        if (!activeTrigger) return;

        const { relatedTarget } = event;
        if (isPopoverElement(relatedTarget)) return;
        if (relatedTarget && getDisabledTrigger(relatedTarget)) return;

        scheduleClose();
    };

    tableEl.addEventListener('mouseover', handleMouseOver);
    tableEl.addEventListener('mouseout', handleMouseOut);

    return () => {
        tableEl.removeEventListener('mouseover', handleMouseOver);
        tableEl.removeEventListener('mouseout', handleMouseOut);
        clearCloseTimer();
    };
};
